import "antd/dist/antd.css";
import styled from "styled-components";
import { getStoryIds } from "./api";
import Story from "./Story";
import { AsyncRequest } from "use-async-request";

const Container = styled.div`
  text-align: center;
  padding: 20px;
  display: flex;
  background-color: #fafafa;
  flex-direction: column;
`;

export default function App() {
  return (
    <Container>
      <h1>Hacker News</h1>
      <AsyncRequest
        requestFunctions={[
          {
            func: getStoryIds,
            payload: { storyType: "topstories" }
          }
        ]}
        success={Story}
      />
    </Container>
  );
}
